import React, { useRef } from 'react';
import {
  Box,
  Typography,
  TextField,
  Paper,
  Chip,
  Alert,
  Button,
  Stack,
  IconButton,
  InputAdornment,
  Collapse,
  Radio,
  Dialog,
  DialogTitle,
  DialogContent,
  Divider,
  DialogActions,
  Tooltip,
  alpha,
  useTheme,
} from '@mui/material';
import {
  AttachFile as AttachFileIcon,
  Delete as DeleteIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
  Description as DescriptionIcon,
  Info as InfoIcon,
  Gavel as GavelIcon,
  Work as WorkIcon,
  Security as SecurityIcon,
  HealthAndSafety as HealthIcon,
  DirectionsCar as CarIcon,
  AccountBalance as AccountBalanceIcon,
  Folder as FolderIcon,
  PlayArrow as PlayArrowIcon,
  Pause as PauseIcon,
  TextFields as TextFieldsIcon,
  Visibility as VisibilityIcon,
} from '@mui/icons-material';
import { DocumentType, AREAS } from './documentTypes';
import AudioRecorder from '../AudioRecorder';
import { transcribeAudio } from '../../services/attachmentService';
import { useSnackbar } from 'notistack';

// Importar formulários específicos
import ContestacaoForm from './forms/ContestacaoForm';
import ReplicaForm from './forms/ReplicaForm';
import ManifestacaoForm from './forms/ManifestacaoForm';
import AlegacoesFinaisForm from './forms/AlegacoesFinaisForm';
import AgravoInstrumentoForm from './forms/AgravoInstrumentoForm';
import AgravoInternoForm from './forms/AgravoInternoForm';
import RecursoEspecialForm from './forms/RecursoEspecialForm';
import EmbargosDeclaracaoForm from './forms/EmbargosDeclaracaoForm';
import CumprimentoSentencaForm from './forms/CumprimentoSentencaForm';
import ApelacaoForm from './forms/ApelacaoForm';
import EmbargosTerceiroForm from './forms/EmbargosTerceiroForm';
import TutelaCautelarForm from './forms/TutelaCautelarForm';
import TutelaAntecipadaForm from './forms/TutelaAntecipadaForm';
import TutelaIncidentalForm from './forms/TutelaIncidentalForm';
import TutelaEvidenciaForm from './forms/TutelaEvidenciaForm';
import AdjudicacaoCompulsoriaForm from './forms/AdjudicacaoCompulsoriaForm';
import SustacaoProtestoForm from './forms/SustacaoProtestoForm';
import BuscaApreensaoMenorForm from './forms/BuscaApreensaoMenorForm';
import EmendaInicialForm from './forms/EmendaInicialForm';
import RecuperacaoJudicialForm from './forms/RecuperacaoJudicialForm';
import MandadoSegurancaForm from './forms/MandadoSegurancaForm';
import ExecucaoTituloExtrajudicialForm from './forms/ExecucaoTituloExtrajudicialForm';
import ContrarrazoesApelacaoForm from './forms/ContrarrazoesApelacaoForm';
import RecursoInominadoForm from './forms/RecursoInominadoForm';
import ContrarrazoesRecursoInominadoForm from './forms/ContrarrazoesRecursoInominadoForm';
import ContraminutaAgravoForm from './forms/ContraminutaAgravoForm';
import ContraminutaAgravoInternoForm from './forms/ContraminutaAgravoInternoForm';
// Removed invalid imports: RecursoOrdinarioForm, ContrarrazoesROForm
import RecursoRevistaForm from './forms/RecursoRevistaForm';
// Removed: ContrarrazoesRRForm (use named import from bundle)
// Removed: HabilitacaoCreditoForm, PedidoFalenciaForm, RequerimentoExtrajudicialForm
import RecursoOrdinarioConstitucionalForm from './forms/RecursoOrdinarioConstitucionalForm';
// Removed: ContrarrazoesROCForm
// Added missing:
import MemoriaisRecursaisForm from './forms/MemoriaisRecursaisForm';
import MemoriaisSTJForm from './forms/MemoriaisSTJForm';
import ContrarrazoesREspForm from './forms/ContrarrazoesREspForm';
import ContraminutaAgravoREspForm from './forms/ContraminutaAgravoREspForm';
import RecursoExtraordinarioForm from './forms/RecursoExtraordinarioForm';
import ContrarrazoesREForm from './forms/ContrarrazoesREForm';
import EmbargosDivergenciaForm from './forms/EmbargosDivergenciaForm';
import ImpugnacaoEmbargosDivergenciaForm from './forms/ImpugnacaoEmbargosDivergenciaForm';
import ContrarrazoesEmbargosDeclaracaoForm from './forms/ContrarrazoesEmbargosDeclaracaoForm';
import ImpugnacaoCumprimentoSentencaForm from './forms/ImpugnacaoCumprimentoSentencaForm';
import EmbargosExecucaoForm from './forms/EmbargosExecucaoForm';
import ImpugnacaoEmbargosExecucaoForm from './forms/ImpugnacaoEmbargosExecucaoForm';
import EmbargosMonitoriaForm from './forms/EmbargosMonitoriaForm';
import ExcecaoPreExecutividadeForm from './forms/ExcecaoPreExecutividadeForm';
import ImpugnacaoPenhoraForm from './forms/ImpugnacaoPenhoraForm';
import ImpugnacaoHomologacaoCalculosForm from './forms/ImpugnacaoHomologacaoCalculosForm';
import PedidoLevantamentoValoresForm from './forms/PedidoLevantamentoValoresForm';
import PedidoPenhoraFaturamentoForm from './forms/PedidoPenhoraFaturamentoForm';
import PedidoPenhoraRostoAutosForm from './forms/PedidoPenhoraRostoAutosForm';
import PedidoExpedicaoRPVForm from './forms/PedidoExpedicaoRPVForm';
import AcaoRescissoriaForm from './forms/AcaoRescissoriaForm';
import AcordoJudicialExtincaoForm from './forms/AcordoJudicialExtincaoForm';
import AcordoDivorcioForm from './forms/AcordoDivorcioForm';
import AcordoAlimentosGuardaForm from './forms/AcordoAlimentosGuardaForm';
import CumprimentoProvisorioForm from './forms/CumprimentoProvisorioForm';
import ImpugnacaoCreditoLiquidacaoForm from './forms/ImpugnacaoCreditoLiquidacaoForm';
import HabilitacaoCreditoRetardatariaForm from './forms/HabilitacaoCreditoRetardatariaForm';
import HabilitacaoCreditoAdministrativaForm from './forms/HabilitacaoCreditoAdministrativaForm';
import AdaptarModeloForm from './forms/AdaptarModeloForm';
import AgravoREspForm from './forms/AgravoREspForm';
import { hasSpecificForm, getFormType } from './forms';

// ========================================
// FORMULÁRIOS POR ÁREA - IMPORTS
// ========================================

// Trabalhista (Arquivos Físicos)
import ReclamacaoTrabalhistaForm from './forms/ReclamacaoTrabalhistaForm';
import ContestacaoTrabalhistaForm from './forms/ContestacaoTrabalhistaForm';
import ReplicaTrabalhistaForm from './forms/ReplicaTrabalhistaForm';
import AgravoPeticaoForm from './forms/AgravoPeticaoForm';
import RecursoOrdinarioTrabalhistaForm from './forms/RecursoOrdinarioTrabalhistaForm';
import ContrarrazoesROTrabalhistaForm from './forms/ContrarrazoesROTrabalhistaForm';
import EmendaInicialTrabalhistaForm from './forms/EmendaInicialTrabalhistaForm';
import ManifestacaoProcessualTrabalhistaForm from './forms/ManifestacaoProcessualTrabalhistaForm';
import QuesitosPericiaisTrabalhistaForm from './forms/QuesitosPericiaisTrabalhistaForm';
import ConsignacaoPagamentoTrabalhistaForm from './forms/ConsignacaoPagamentoTrabalhistaForm';
import RecursoAdesivoForm from './forms/RecursoAdesivoForm';

// Trabalhista (Definidos no Bundle)
import {
  AlegacoesFinaisTrabalhistaForm,
  EmbargosDeclaracaoTrabalhistaForm,
  ContrarrazoesRRForm,
  AgravoInstrumentoTrabalhistaForm,
  MandadoSegurancaTrabalhistaForm,
  ImpugnacaoLiquidacaoTrabalhistaForm,
  ExcecaoIncompetenciaTrabalhistaForm,
  ImpugnacaoValorCausaTrabalhistaForm,
  AcaoCumprimentoTrabalhistaForm,
  HabeasCorpusTrabalhistaForm,
  AgravoRegimentalTrabalhistaForm,
  EmbargosSdiTstForm,
  MemoriaisRecursaisTrabalhistaForm,
  RecursoExtraordinarioTrabalhistaForm,
  ContrarrazoesRETrabalhistaForm,
  ContraminutaAgravoInstrumentoTrabalhistaForm,
  ContraminutaAgravoRespTrabalhistaForm,
  ContrarrazoesEmbargosDeclaracaoTrabalhistaForm,
  AcaoRescisoriaTrabalhistaForm,
  CumprimentoSentencaTrabalhistaForm,
  ImpugnacaoCumprimentoSentencaTrabalhistaForm,
  EmbargosExecucaoTrabalhistaForm,
  ImpugnacaoEmbargosExecucaoTrabalhistaForm,
  ContrarrazoesAgravoPeticaoForm,
  RecursoOrdinarioConstitucionalTrabalhistaForm,
  PedidoCumprimentoProvisorioSentencaTrabalhistaForm,
  ImpugnacaoHomologacaoCalculosTrabalhistaForm,
  EmbargosMonitoriaTrabalhistaForm,
  PedidoPenhoraFaturamentoTrabalhistaForm,
  PedidoPenhoraRostoAutosTrabalhistaForm,
  PedidoExpedicaoRPVTrabalhistaForm,
  PedidoRevisaoTrabalhistaForm,
  AcordoExtrajudicialTrabalhistaForm,
  ContraminutaAgravoInternoTrabalhistaForm,
} from './forms/trabalhistaForms';

// Criminal/Penal
import {
  HabeasCorpusForm,
  QueixaCrimeForm,
  DefesaPreviaCriminalForm,
  RespostaAcusacaoForm,
  PedidoLiberdadeProvisoriaForm,
  RecursoSentidoEstritoForm,
  RevisaoCriminalForm,
  AlegacoesFinaisCriminaisForm,
  ApelacaoCriminalForm,
  PedidoProgressaoRegimeForm,
  RevogacaoPrisaoPreventivaForm,
  RevogacaoPrisaoMedidasForm,
  DenunciaForm,
  EmendaInicialCriminalForm,
  ReplicaCriminalForm,
  ExcecaoSuspeicaoCriminalForm,
  RelaxamentoPrisaoForm,
  RevogacaoMedidasProtetivasForm,
  QuesitosPericialsCriminalForm,
  ManifestacaoProcessualCriminalForm,
  ContrarrazoesApelacaoCriminalForm,
  ContrarrazoesRESEForm,
  RecursoOrdinarioConstitucionalCriminalForm,
  MemoriaisRecursaisCriminalForm,
  MemoriaisSTJCriminalForm,
  RecursoEspecialCriminalForm,
  ContrarrazoesRespCriminalForm,
  AgravoRespCriminalForm,
  ContraminutaAgravoRespCriminalForm,
  RecursoExtraordinarioCriminalForm,
  ContrarrazoesRECriminalForm,
  EmbargosDeclaracaoCriminalForm,
  ContrarrazoesEmbargosDeclaracaoCriminalForm,
  RestituicaoCoisaApreendidaForm,
  PeticaoIncidenteExecucaoForm,
  AgravoExecucaoPenalForm,
  ContrarrazoesAgravoExecucaoForm,
  LivramentoCondicionalForm,
  IndultoNatalinoForm,
  PecaModeloCriminalForm,
} from './forms/criminalForms';

// Previdenciário
import {
  ConcessaoBeneficioForm,
  RevisaoBeneficioForm,
  RecursoEspecialCRPSForm,
  RecursoOrdinarioCRPSForm,
  RequerimentoBeneficioForm,
  EmendaInicialPrevidenciarioForm,
  ContestacaoPrevidenciarioForm,
  ReplicaPrevidenciarioForm,
  ManifestacaoPrevidenciarioForm,
  ProducaoProvasPrevidenciarioForm,
  QuesitosPericiaisisPrevidenciarioForm,
  AlegacoesFinaisPrevidenciarioForm,
  RecursoInominadoPrevidenciarioForm,
  ApelacaoPrevidenciarioForm,
  ContrarrazoesApelacaoPrevidenciarioForm,
  AgravoInstrumentoPrevidenciarioForm,
  ContraminutaAgravoPrevidenciarioForm,
  AgravoInternoPrevidenciarioForm,
  ContraminutaAgravoInternoPrevidenciarioForm,
  CumprimentoSentencaPrevidenciarioForm,
  ImpugnacaoCumprimentoPrevidenciarioForm,
  ImpugnacaoHomologacaoPrevidenciarioForm,
  MemoriaisPrevidenciarioForm,
  MemoriaisSTJPrevidenciarioForm,
  RecursoEspecialPrevidenciarioForm,
  ContrarrazoesRespPrevidenciarioForm,
  RecursoExtraordinarioPrevidenciarioForm,
  ContrarrazoesREPrevidenciarioForm,
  AgravoRespPrevidenciarioForm,
  ContraminutaAgravoRespPrevidenciarioForm,
  RecursoOrdinarioConstitucionalPrevidenciarioForm,
  MandadoSegurancaPrevidenciarioForm,
  RPVPrevidenciarioForm,
  PecaModeloPrevidenciarioForm,
} from './forms/previdenciarioForms';

// Trânsito
import {
  DefesaPreviaDetranForm,
  RecursoJARIForm,
  RecursoCETRANForm,
  ManifestacaoTransitoForm,
  PeticaoInicialTransitoForm,
  ContraminutaAgravoTransitoForm,
  ContrarrazoesRespTransitoForm,
  ContrarrazoesRETransitoForm,
  ContrarrazoesEDTransitoForm,
  ContrarrazoesApelacaoTransitoForm,
  EmbargosDeclaracaoTransitoForm,
  EmbargosTerceiroTransitoForm,
  ExcecaoPreExecutividadeTransitoForm,
  ReplicaTransitoForm,
  ImpugnacaoCumprimentoTransitoForm,
  ImpugnacaoEmbargosExecucaoTransitoForm,
  ImpugnacaoHomologacaoTransitoForm,
  ExecucaoTituloTransitoForm,
  MandadoSegurancaTransitoForm,
  ManifestacaoImpugnacaoEmbargosTransitoForm,
  ProducaoProvasTransitoForm,
  RecursoEspecialTransitoForm,
  RecursoExtraordinarioTransitoForm,
  RecursoInominadoTransitoForm,
  AgravoInstrumentoTransitoForm,
  QuesitosPericiaisisTransitoForm,
  MemoriaisTransitoForm,
  PecaModeloTransitoForm,
  RecursoOrdinarioConstitucionalTransitoForm,
} from './forms/transitoForms';

// Magistratura
import {
  AcordaoForm,
  DecisaoJudicialForm,
  SentencaForm,
} from './forms/magistraturaForms';

// Recesso
import {
  IndultoNatalinoRecessoForm,
  SustacaoProtestoRecessoForm,
  BuscaApreensaoMenorRecessoForm,
  ContranotificacaoForm,
  HabeasCorpusRecessoForm,
  ImpugnacaoPenhoraRecessoForm,
  AdjudicacaoCompulsoriaRecessoForm,
  MandadoSegurancaRecessoForm,
  ManifestacaoRecessoForm,
  NotificacaoExtrajudicialForm,
  CumprimentoProvisorioRecessoForm,
  RPVRecessoForm,
  LevantamentoValoresForm,
  LiberdadeProvisoriaRecessoForm,
  PenhoraFaturamentoForm,
  PenhoraRostoAutosForm,
  RelaxamentoPrisaoRecessoForm,
  RevogacaoPreventivaRecessoForm,
  RevogacaoPreventivaMedidasRecessoForm,
  PeticaoIncidenteRecessoForm,
  TutelaAntecipadaAntecedenteForm,
  TutelaCautelarAntecedenteForm,
  TutelaAntecipadaIncidentalForm,
  TutelaEvidenciaRecessoForm,
  TutelaCautelarIncidentalForm,
} from './forms/recessoForms';

// Contratos
import {
  CriarContratoForm,
  RevisarContratoForm,
  AnaliseContratoParecerrForm,
  AnaliseNegociacaoForm,
  AnaliseRiscoRescisaoForm,
  CompararContratosForm,
  CriarAditivoForm,
  CriarClausulaForm,
  TermoEncerramentoForm,
  TermosUsoForm,
  ContratoModeloForm,
} from './forms/contratoForms';

// Extrajudicial
import {
  AcordoAlimentosGuardaVisitasForm,
  AcordoDivorcioCompletoForm,
  ContranotificacaoExtrajudicialForm,
  NotificacaoExtrajudicialExtForm,
  ParecerJuridicoForm,
  InventarioExtrajudicialForm,
  ProcuracaoForm,
  TestamentoParticularForm,
} from './forms/extrajudicialForms';

interface DynamicDocumentFormProps {
  documentType: DocumentType;
  values: Record<string, any>;
  onChange: (values: Record<string, any>) => void;
  uploadedFiles: File[];
  onFileUpload: (files: File[]) => void;
  onFileRemove: (index: number) => void;
}

// Ícones por área
const AREA_ICONS: Record<string, React.ReactNode> = {
  civel: <GavelIcon sx={{ fontSize: 24 }} />,
  trabalhista: <WorkIcon sx={{ fontSize: 24 }} />,
  criminal: <SecurityIcon sx={{ fontSize: 24 }} />,
  previdenciario: <HealthIcon sx={{ fontSize: 24 }} />,
  transito: <CarIcon sx={{ fontSize: 24 }} />,
  magistratura: <AccountBalanceIcon sx={{ fontSize: 24 }} />,
  recesso: <FolderIcon sx={{ fontSize: 24 }} />,
  ambiental: <FolderIcon sx={{ fontSize: 24 }} />,
  familia: <FolderIcon sx={{ fontSize: 24 }} />,
  geral: <DescriptionIcon sx={{ fontSize: 24 }} />,
};

// Estilos de escrita disponíveis
const WRITING_STYLES = [
  {
    id: 'padrao',
    name: 'Padrão Jurídico AI',
    description: 'Estilo profissional equilibrado entre formalidade e clareza',
  },
  {
    id: 'formal',
    name: 'Formal Tradicional',
    description: 'Linguagem altamente formal e técnica',
  },
  {
    id: 'objetivo',
    name: 'Objetivo e Conciso',
    description: 'Direto ao ponto, sem floreios',
  },
  {
    id: 'detalhado',
    name: 'Detalhado e Fundamentado',
    description: 'Argumentação extensa com muitas referências',
  },
];

const DynamicDocumentForm: React.FC<DynamicDocumentFormProps> = ({
  documentType,
  values,
  onChange,
  uploadedFiles,
  onFileUpload,
  onFileRemove,
}) => {
  const theme = useTheme();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [showFileSection, setShowFileSection] = React.useState(false);
  const [selectedStyle, setSelectedStyle] = React.useState('padrao');

  // States for Audio Player and Transcription
  const [transcriptions, setTranscriptions] = React.useState<Map<string, string>>(new Map());
  const [playingAudio, setPlayingAudio] = React.useState<string | null>(null);
  const audioRef = React.useRef<HTMLAudioElement | null>(null);
  const [transcriptionDialog, setTranscriptionDialog] = React.useState<{
    open: boolean;
    fileName: string;
    text: string;
  }>({ open: false, fileName: '', text: '' });

  const { enqueueSnackbar } = useSnackbar();
  const areaConfig = AREAS.find(a => a.id === documentType.area);

  const handleFieldChange = (fieldId: string, value: any) => {
    onChange({
      ...values,
      [fieldId]: value,
    });
  };

  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      onFileUpload(Array.from(files));
    }
    // Reset input
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  // Audio Player Handlers
  const handleToggleAudio = (file: File) => {
    if (playingAudio === file.name) {
      // Stop playing
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }
      setPlayingAudio(null);
    } else {
      // Start playing
      if (audioRef.current) {
        audioRef.current.pause();
      }

      const url = URL.createObjectURL(file);
      const audio = new Audio(url);
      audioRef.current = audio;

      audio.onended = () => {
        setPlayingAudio(null);
        URL.revokeObjectURL(url);
      };

      audio.play().catch(e => {
        console.error("Error playing audio:", e);
        enqueueSnackbar('Erro ao reproduzir áudio', { variant: 'error' });
        setPlayingAudio(null);
      });

      setPlayingAudio(file.name);
    }
  };

  const handleRecordingComplete = async (audioBlob: Blob) => {
    try {
      // 1. Criar arquivo
      const fileName = `audio_${Date.now()}.webm`;
      const audioFile = new File([audioBlob], fileName, {
        type: 'audio/webm',
      });

      // 2. Anexar arquivo
      onFileUpload([audioFile]);

      // 3. Notificar início da transcrição
      enqueueSnackbar('Transcrevendo áudio...', { variant: 'info' });

      // 4. Transcrever
      const response = await transcribeAudio(audioFile);

      if (response.success && response.transcription) {
        // 5. Adicionar transcrição ao estado local e aos fatos do caso
        setTranscriptions(prev => new Map(prev).set(fileName, response.transcription));

        const currentFacts = values.fatos_caso || '';
        const newFacts = currentFacts
          ? `${currentFacts}\n\n[Transcrição de Áudio - ${fileName}]: ${response.transcription}`
          : response.transcription;

        handleFieldChange('fatos_caso', newFacts);

        enqueueSnackbar('Áudio transcrito e adicionado aos fatos do caso!', { variant: 'success' });
      }
    } catch (error) {
      console.error('Erro ao transcrever áudio:', error);
      enqueueSnackbar('Erro ao transcrever áudio. O arquivo foi anexado, mas não foi possível converter em texto.', { variant: 'error' });
    }
  };

  const formatCurrency = (value: string) => {
    const numbers = value.replace(/\D/g, '');
    const amount = parseInt(numbers || '0', 10) / 100;
    return amount.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  // ========================================
  // VERIFICAR SE TEM FORMULÁRIO ESPECÍFICO
  // ========================================
  if (hasSpecificForm(documentType.id)) {
    const formType = getFormType(documentType.id);

    const formProps = {
      documentType,
      values,
      onChange,
      uploadedFiles,
      onFileUpload,
      onFileRemove,
    };

    switch (formType) {
      case 'contestacao':
        return <ContestacaoForm {...formProps} />;
      case 'replica':
        return <ReplicaForm {...formProps} />;
      case 'manifestacao':
        return <ManifestacaoForm {...formProps} />;
      case 'alegacoes_finais':
        return <AlegacoesFinaisForm {...formProps} />;
      case 'agravo_instrumento':
        return <AgravoInstrumentoForm {...formProps} />;
      case 'agravo_interno':
        return <AgravoInternoForm {...formProps} />;
      case 'recurso_especial':
        return <RecursoEspecialForm {...formProps} />;
      case 'embargos_declaracao':
        return <EmbargosDeclaracaoForm {...formProps} />;
      case 'cumprimento_sentenca':
        return <CumprimentoSentencaForm {...formProps} />;
      case 'apelacao':
        return <ApelacaoForm {...formProps} />;
      case 'embargos_terceiro':
        return <EmbargosTerceiroForm {...formProps} />;
      case 'tutela_cautelar':
        return <TutelaCautelarForm {...formProps} />;
      case 'tutela_antecipada':
        return <TutelaAntecipadaForm {...formProps} />;
      case 'tutela_incidental':
        return <TutelaIncidentalForm {...formProps} />;
      case 'tutela_evidencia':
        return <TutelaEvidenciaForm {...formProps} />;
      case 'adjudicacao_compulsoria':
        return <AdjudicacaoCompulsoriaForm {...formProps} />;
      case 'sustacao_protesto':
        return <SustacaoProtestoForm {...formProps} />;
      case 'busca_apreensao_menor':
        return <BuscaApreensaoMenorForm {...formProps} />;
      case 'emenda_inicial':
        return <EmendaInicialForm {...formProps} />;
      case 'recuperacao_judicial':
        return <RecuperacaoJudicialForm {...formProps} />;
      case 'mandado_seguranca':
        return <MandadoSegurancaForm {...formProps} />;
      case 'execucao_titulo_extrajudicial':
        return <ExecucaoTituloExtrajudicialForm {...formProps} />;
      case 'contrarrazoes_apelacao':
        return <ContrarrazoesApelacaoForm {...formProps} />;
      case 'recurso_inominado':
        return <RecursoInominadoForm {...formProps} />;
      case 'contrarrazoes_recurso_inominado':
        return <ContrarrazoesRecursoInominadoForm {...formProps} />;
      case 'contraminuta_agravo':
        return <ContraminutaAgravoForm {...formProps} />;
      case 'contraminuta_agravo_interno':
        return <ContraminutaAgravoInternoForm {...formProps} />;
      case 'recurso_ordinario_constitucional':
        return <RecursoOrdinarioConstitucionalForm {...formProps} />;
      case 'memoriais_recursais':
        return <MemoriaisRecursaisForm {...formProps} />;
      case 'memoriais_stj':
        return <MemoriaisSTJForm {...formProps} />;
      case 'contrarrazoes_resp':
        return <ContrarrazoesREspForm {...formProps} />;
      case 'agravo_resp':
        return <AgravoREspForm {...formProps} />;
      case 'contraminuta_agravo_resp':
        return <ContraminutaAgravoREspForm {...formProps} />;
      case 'recurso_extraordinario':
        return <RecursoExtraordinarioForm {...formProps} />;
      case 'contrarrazoes_re':
        return <ContrarrazoesREForm {...formProps} />;
      case 'embargos_divergencia':
        return <EmbargosDivergenciaForm {...formProps} />;
      case 'impugnacao_embargos_divergencia':
        return <ImpugnacaoEmbargosDivergenciaForm {...formProps} />;
      case 'contrarrazoes_embargos_declaracao':
        return <ContrarrazoesEmbargosDeclaracaoForm {...formProps} />;
      case 'impugnacao_cumprimento_sentenca':
        return <ImpugnacaoCumprimentoSentencaForm {...formProps} />;
      case 'embargos_execucao':
        return <EmbargosExecucaoForm {...formProps} />;
      case 'impugnacao_embargos_execucao':
        return <ImpugnacaoEmbargosExecucaoForm {...formProps} />;
      case 'embargos_monitoria':
        return <EmbargosMonitoriaForm {...formProps} />;
      case 'excecao_pre_executividade':
        return <ExcecaoPreExecutividadeForm {...formProps} />;
      case 'impugnacao_penhora':
        return <ImpugnacaoPenhoraForm {...formProps} />;
      case 'impugnacao_homologacao_calculos':
        return <ImpugnacaoHomologacaoCalculosForm {...formProps} />;
      case 'pedido_levantamento_valores':
        return <PedidoLevantamentoValoresForm {...formProps} />;
      case 'pedido_penhora_faturamento':
        return <PedidoPenhoraFaturamentoForm {...formProps} />;
      case 'pedido_penhora_rosto_autos':
        return <PedidoPenhoraRostoAutosForm {...formProps} />;
      case 'pedido_expedicao_rpv':
        return <PedidoExpedicaoRPVForm {...formProps} />;
      case 'acao_rescissoria':
        return <AcaoRescissoriaForm {...formProps} />;
      case 'acordo_judicial_extincao':
        return <AcordoJudicialExtincaoForm {...formProps} />;
      case 'acordo_divorcio':
        return <AcordoDivorcioForm {...formProps} />;
      case 'acordo_alimentos_guarda':
        return <AcordoAlimentosGuardaForm {...formProps} />;
      case 'cumprimento_provisorio':
        return <CumprimentoProvisorioForm {...formProps} />;
      case 'impugnacao_credito_liquidacao':
        return <ImpugnacaoCreditoLiquidacaoForm {...formProps} />;
      case 'habilitacao_credito_retardataria':
        return <HabilitacaoCreditoRetardatariaForm {...formProps} />;
      case 'habilitacao_credito_administrativa':
        return <HabilitacaoCreditoAdministrativaForm {...formProps} />;
      case 'adaptar_modelo':
        return <AdaptarModeloForm {...formProps} />;

      // ========================================
      // TRABALHISTA
      // ========================================
      case 'reclamacao_trabalhista':
        return <ReclamacaoTrabalhistaForm {...formProps} />;
      case 'contestacao_trabalhista':
        return <ContestacaoTrabalhistaForm {...formProps} />;
      case 'replica_trabalhista':
        return <ReplicaTrabalhistaForm {...formProps} />;
      case 'agravo_peticao':
        return <AgravoPeticaoForm {...formProps} />;
      case 'recurso_ordinario_trabalhista':
        return <RecursoOrdinarioTrabalhistaForm {...formProps} />;
      case 'contrarrazoes_ro_trabalhista':
        return <ContrarrazoesROTrabalhistaForm {...formProps} />;
      case 'recurso_revista':
        return <RecursoRevistaForm {...formProps} />;
      case 'contrarrazoes_recurso_revista':
        return <ContrarrazoesRRForm {...formProps} />;
      case 'acordo_extrajudicial_trabalhista':
        return <AcordoExtrajudicialTrabalhistaForm {...formProps} />;
      case 'emenda_inicial_trabalhista':
        return <EmendaInicialTrabalhistaForm {...formProps} />;
      case 'manifestacao_trabalhista':
        return <ManifestacaoProcessualTrabalhistaForm {...formProps} />;
      case 'quesitos_periciais_trabalhista':
        return <QuesitosPericiaisTrabalhistaForm {...formProps} />;
      case 'consignacao_pagamento_trabalhista':
        return <ConsignacaoPagamentoTrabalhistaForm {...formProps} />;
      case 'alegacoes_finais_trabalhista':
        return <AlegacoesFinaisTrabalhistaForm {...formProps} />;
      case 'embargos_declaracao_trabalhista':
        return <EmbargosDeclaracaoTrabalhistaForm {...formProps} />;
      case 'agravo_instrumento_trabalhista':
        return <AgravoInstrumentoTrabalhistaForm {...formProps} />;
      case 'mandado_seguranca_trabalhista':
        return <MandadoSegurancaTrabalhistaForm {...formProps} />;
      case 'impugnacao_liquidacao_trabalhista':
        return <ImpugnacaoLiquidacaoTrabalhistaForm {...formProps} />;
      case 'excecao_incompetencia_trabalhista':
        return <ExcecaoIncompetenciaTrabalhistaForm {...formProps} />;
      case 'impugnacao_valor_causa_trabalhista':
        return <ImpugnacaoValorCausaTrabalhistaForm {...formProps} />;
      case 'acao_cumprimento_trabalhista':
        return <AcaoCumprimentoTrabalhistaForm {...formProps} />;
      case 'habeas_corpus_trabalhista':
        return <HabeasCorpusTrabalhistaForm {...formProps} />;
      case 'agravo_regimental_trabalhista':
        return <AgravoRegimentalTrabalhistaForm {...formProps} />;
      case 'embargos_sdi_tst':
        return <EmbargosSdiTstForm {...formProps} />;
      case 'memoriais_recursais_trabalhista':
        return <MemoriaisRecursaisTrabalhistaForm {...formProps} />;
      case 'recurso_extraordinario_trabalhista':
        return <RecursoExtraordinarioTrabalhistaForm {...formProps} />;
      case 'contrarrazoes_re_trabalhista':
        return <ContrarrazoesRETrabalhistaForm {...formProps} />;
      case 'contraminuta_agravo_instrumento_trabalhista':
        return <ContraminutaAgravoInstrumentoTrabalhistaForm {...formProps} />;
      case 'contraminuta_agravo_resp_trabalhista':
        return <ContraminutaAgravoRespTrabalhistaForm {...formProps} />;
      case 'contrarrazoes_embargos_declaracao_trabalhista':
        return <ContrarrazoesEmbargosDeclaracaoTrabalhistaForm {...formProps} />;
      case 'acao_rescisoria_trabalhista':
        return <AcaoRescisoriaTrabalhistaForm {...formProps} />;
      case 'cumprimento_sentenca_trabalhista':
        return <CumprimentoSentencaTrabalhistaForm {...formProps} />;
      case 'impugnacao_cumprimento_sentenca_trabalhista':
        return <ImpugnacaoCumprimentoSentencaTrabalhistaForm {...formProps} />;
      case 'embargos_execucao_trabalhista':
        return <EmbargosExecucaoTrabalhistaForm {...formProps} />;
      case 'impugnacao_embargos_execucao_trabalhista':
        return <ImpugnacaoEmbargosExecucaoTrabalhistaForm {...formProps} />;
      case 'contrarrazoes_agravo_peticao':
        return <ContrarrazoesAgravoPeticaoForm {...formProps} />;
      case 'recurso_ordinario_constitucional_trabalhista':
        return <RecursoOrdinarioConstitucionalTrabalhistaForm {...formProps} />;
      case 'cumprimento_provisorio_sentenca_trabalhista':
        return <PedidoCumprimentoProvisorioSentencaTrabalhistaForm {...formProps} />;
      case 'impugnacao_homologacao_calculos_trabalhista':
        return <ImpugnacaoHomologacaoCalculosTrabalhistaForm {...formProps} />;
      case 'embargos_monitoria_trabalhista':
        return <EmbargosMonitoriaTrabalhistaForm {...formProps} />;
      case 'pedido_penhora_faturamento_trabalhista':
        return <PedidoPenhoraFaturamentoTrabalhistaForm {...formProps} />;
      case 'pedido_penhora_rosto_autos_trabalhista':
        return <PedidoPenhoraRostoAutosTrabalhistaForm {...formProps} />;
      case 'pedido_expedicao_rpv_trabalhista':
        return <PedidoExpedicaoRPVTrabalhistaForm {...formProps} />;
      case 'pedido_revisao_trabalhista':
        return <PedidoRevisaoTrabalhistaForm {...formProps} />;
      case 'contraminuta_agravo_interno_trabalhista':
        return <ContraminutaAgravoInternoTrabalhistaForm {...formProps} />;
      case 'recurso_adesivo':
        return <RecursoAdesivoForm {...formProps} />;

      // ========================================
      // CRIMINAL / PENAL
      // ========================================
      case 'habeas_corpus':
        return <HabeasCorpusForm {...formProps} />;
      case 'queixa_crime':
        return <QueixaCrimeForm {...formProps} />;
      case 'defesa_previa_criminal':
        return <DefesaPreviaCriminalForm {...formProps} />;
      case 'resposta_acusacao':
        return <RespostaAcusacaoForm {...formProps} />;
      case 'liberdade_provisoria':
        return <PedidoLiberdadeProvisoriaForm {...formProps} />;
      case 'recurso_sentido_estrito':
        return <RecursoSentidoEstritoForm {...formProps} />;
      case 'revisao_criminal':
        return <RevisaoCriminalForm {...formProps} />;
      case 'alegacoes_finais_criminais':
        return <AlegacoesFinaisCriminaisForm {...formProps} />;
      case 'apelacao_criminal':
        return <ApelacaoCriminalForm {...formProps} />;
      case 'pedido_progressao_regime':
        return <PedidoProgressaoRegimeForm {...formProps} />;
      case 'revogacao_prisao_preventiva':
        return <RevogacaoPrisaoPreventivaForm {...formProps} />;
      case 'revogacao_prisao_medidas':
        return <RevogacaoPrisaoMedidasForm {...formProps} />;
      case 'denuncia':
        return <DenunciaForm {...formProps} />;
      case 'emenda_inicial_criminal':
        return <EmendaInicialCriminalForm {...formProps} />;
      case 'replica_criminal':
        return <ReplicaCriminalForm {...formProps} />;
      case 'excecao_suspeicao_criminal':
        return <ExcecaoSuspeicaoCriminalForm {...formProps} />;
      case 'relaxamento_prisao':
        return <RelaxamentoPrisaoForm {...formProps} />;
      case 'revogacao_medidas_protetivas':
        return <RevogacaoMedidasProtetivasForm {...formProps} />;
      case 'quesitos_periciais_criminal':
        return <QuesitosPericialsCriminalForm {...formProps} />;
      case 'manifestacao_processual_criminal':
        return <ManifestacaoProcessualCriminalForm {...formProps} />;
      case 'contrarrazoes_apelacao_criminal':
        return <ContrarrazoesApelacaoCriminalForm {...formProps} />;
      case 'contrarrazoes_rese':
        return <ContrarrazoesRESEForm {...formProps} />;
      case 'recurso_ordinario_constitucional_criminal':
        return <RecursoOrdinarioConstitucionalCriminalForm {...formProps} />;
      case 'memoriais_recursais_criminal':
        return <MemoriaisRecursaisCriminalForm {...formProps} />;
      case 'memoriais_stj_criminal':
        return <MemoriaisSTJCriminalForm {...formProps} />;
      case 'recurso_especial_criminal':
        return <RecursoEspecialCriminalForm {...formProps} />;
      case 'contrarrazoes_resp_criminal':
        return <ContrarrazoesRespCriminalForm {...formProps} />;
      case 'agravo_resp_criminal':
        return <AgravoRespCriminalForm {...formProps} />;
      case 'contraminuta_agravo_resp_criminal':
        return <ContraminutaAgravoRespCriminalForm {...formProps} />;
      case 'recurso_extraordinario_criminal':
        return <RecursoExtraordinarioCriminalForm {...formProps} />;
      case 'contrarrazoes_re_criminal':
        return <ContrarrazoesRECriminalForm {...formProps} />;
      case 'embargos_declaracao_criminal':
        return <EmbargosDeclaracaoCriminalForm {...formProps} />;
      case 'contrarrazoes_embargos_declaracao_criminal':
        return <ContrarrazoesEmbargosDeclaracaoCriminalForm {...formProps} />;
      case 'restituicao_coisa_apreendida':
        return <RestituicaoCoisaApreendidaForm {...formProps} />;
      case 'peticao_incidente_execucao':
        return <PeticaoIncidenteExecucaoForm {...formProps} />;
      case 'agravo_execucao_penal':
        return <AgravoExecucaoPenalForm {...formProps} />;
      case 'contrarrazoes_agravo_execucao':
        return <ContrarrazoesAgravoExecucaoForm {...formProps} />;
      case 'livramento_condicional':
        return <LivramentoCondicionalForm {...formProps} />;
      case 'indulto_natalino':
        return <IndultoNatalinoForm {...formProps} />;
      case 'peca_modelo_criminal':
        return <PecaModeloCriminalForm {...formProps} />;

      // ========================================
      // PREVIDENCIÁRIO
      // ========================================
      case 'concessao_beneficio':
        return <ConcessaoBeneficioForm {...formProps} />;
      case 'revisao_beneficio':
        return <RevisaoBeneficioForm {...formProps} />;
      case 'recurso_especial_previdenciario':
        return <RecursoEspecialCRPSForm {...formProps} />;
      case 'recurso_ordinario_previdenciario':
        return <RecursoOrdinarioCRPSForm {...formProps} />;
      case 'requerimento_beneficio':
        return <RequerimentoBeneficioForm {...formProps} />;
      case 'emenda_inicial_previdenciario':
        return <EmendaInicialPrevidenciarioForm {...formProps} />;
      case 'contestacao_previdenciario':
        return <ContestacaoPrevidenciarioForm {...formProps} />;
      case 'replica_previdenciario':
        return <ReplicaPrevidenciarioForm {...formProps} />;
      case 'manifestacao_previdenciario':
        return <ManifestacaoPrevidenciarioForm {...formProps} />;
      case 'producao_provas_previdenciario':
        return <ProducaoProvasPrevidenciarioForm {...formProps} />;
      case 'quesitos_periciais_previdenciario':
        return <QuesitosPericiaisisPrevidenciarioForm {...formProps} />;
      case 'alegacoes_finais_previdenciario':
        return <AlegacoesFinaisPrevidenciarioForm {...formProps} />;
      case 'recurso_inominado_previdenciario':
        return <RecursoInominadoPrevidenciarioForm {...formProps} />;
      case 'apelacao_previdenciario':
        return <ApelacaoPrevidenciarioForm {...formProps} />;
      case 'contrarrazoes_apelacao_previdenciario':
        return <ContrarrazoesApelacaoPrevidenciarioForm {...formProps} />;
      case 'agravo_instrumento_previdenciario':
        return <AgravoInstrumentoPrevidenciarioForm {...formProps} />;
      case 'contraminuta_agravo_previdenciario':
        return <ContraminutaAgravoPrevidenciarioForm {...formProps} />;
      case 'agravo_interno_previdenciario':
        return <AgravoInternoPrevidenciarioForm {...formProps} />;
      case 'contraminuta_agravo_interno_previdenciario':
        return <ContraminutaAgravoInternoPrevidenciarioForm {...formProps} />;
      case 'cumprimento_sentenca_previdenciario':
        return <CumprimentoSentencaPrevidenciarioForm {...formProps} />;
      case 'impugnacao_cumprimento_previdenciario':
        return <ImpugnacaoCumprimentoPrevidenciarioForm {...formProps} />;
      case 'impugnacao_homologacao_previdenciario':
        return <ImpugnacaoHomologacaoPrevidenciarioForm {...formProps} />;
      case 'memoriais_previdenciario':
        return <MemoriaisPrevidenciarioForm {...formProps} />;
      case 'memoriais_stj_previdenciario':
        return <MemoriaisSTJPrevidenciarioForm {...formProps} />;
      case 'recurso_especial_previdenciario_judicial':
        return <RecursoEspecialPrevidenciarioForm {...formProps} />;
      case 'contrarrazoes_resp_previdenciario':
        return <ContrarrazoesRespPrevidenciarioForm {...formProps} />;
      case 'recurso_extraordinario_previdenciario':
        return <RecursoExtraordinarioPrevidenciarioForm {...formProps} />;
      case 'contrarrazoes_re_previdenciario':
        return <ContrarrazoesREPrevidenciarioForm {...formProps} />;
      case 'agravo_resp_previdenciario':
        return <AgravoRespPrevidenciarioForm {...formProps} />;
      case 'contraminuta_agravo_resp_previdenciario':
        return <ContraminutaAgravoRespPrevidenciarioForm {...formProps} />;
      case 'recurso_ordinario_constitucional_previdenciario':
        return <RecursoOrdinarioConstitucionalPrevidenciarioForm {...formProps} />;
      case 'mandado_seguranca_previdenciario':
        return <MandadoSegurancaPrevidenciarioForm {...formProps} />;
      case 'rpv_previdenciario':
        return <RPVPrevidenciarioForm {...formProps} />;
      case 'peca_modelo_previdenciario':
        return <PecaModeloPrevidenciarioForm {...formProps} />;

      // ========================================
      // TRÂNSITO
      // ========================================
      case 'defesa_previa_detran':
        return <DefesaPreviaDetranForm {...formProps} />;
      case 'recurso_jari':
        return <RecursoJARIForm {...formProps} />;
      case 'recurso_cetran':
        return <RecursoCETRANForm {...formProps} />;
      case 'manifestacao_transito':
        return <ManifestacaoTransitoForm {...formProps} />;
      case 'peticao_inicial_transito':
        return <PeticaoInicialTransitoForm {...formProps} />;
      case 'contraminuta_agravo_transito':
        return <ContraminutaAgravoTransitoForm {...formProps} />;
      case 'contrarrazoes_resp_transito':
        return <ContrarrazoesRespTransitoForm {...formProps} />;
      case 'contrarrazoes_re_transito':
        return <ContrarrazoesRETransitoForm {...formProps} />;
      case 'contrarrazoes_ed_transito':
        return <ContrarrazoesEDTransitoForm {...formProps} />;
      case 'contrarrazoes_apelacao_transito':
        return <ContrarrazoesApelacaoTransitoForm {...formProps} />;
      case 'embargos_declaracao_transito':
        return <EmbargosDeclaracaoTransitoForm {...formProps} />;
      case 'embargos_terceiro_transito':
        return <EmbargosTerceiroTransitoForm {...formProps} />;
      case 'excecao_pre_executividade_transito':
        return <ExcecaoPreExecutividadeTransitoForm {...formProps} />;
      case 'replica_transito':
        return <ReplicaTransitoForm {...formProps} />;
      case 'impugnacao_cumprimento_transito':
        return <ImpugnacaoCumprimentoTransitoForm {...formProps} />;
      case 'impugnacao_embargos_execucao_transito':
        return <ImpugnacaoEmbargosExecucaoTransitoForm {...formProps} />;
      case 'impugnacao_homologacao_transito':
        return <ImpugnacaoHomologacaoTransitoForm {...formProps} />;
      case 'execucao_titulo_transito':
        return <ExecucaoTituloTransitoForm {...formProps} />;
      case 'mandado_seguranca_transito':
        return <MandadoSegurancaTransitoForm {...formProps} />;
      case 'manifestacao_impugnacao_embargos_transito':
        return <ManifestacaoImpugnacaoEmbargosTransitoForm {...formProps} />;
      case 'producao_provas_transito':
        return <ProducaoProvasTransitoForm {...formProps} />;
      case 'recurso_especial_transito':
        return <RecursoEspecialTransitoForm {...formProps} />;
      case 'recurso_extraordinario_transito':
        return <RecursoExtraordinarioTransitoForm {...formProps} />;
      case 'recurso_inominado_transito':
        return <RecursoInominadoTransitoForm {...formProps} />;
      case 'agravo_instrumento_transito':
        return <AgravoInstrumentoTransitoForm {...formProps} />;
      case 'quesitos_periciais_transito':
        return <QuesitosPericiaisisTransitoForm {...formProps} />;
      case 'memoriais_transito':
        return <MemoriaisTransitoForm {...formProps} />;
      case 'peca_modelo_transito':
        return <PecaModeloTransitoForm {...formProps} />;
      case 'recurso_ordinario_constitucional_transito':
        return <RecursoOrdinarioConstitucionalTransitoForm {...formProps} />;

      // ========================================
      // MAGISTRATURA
      // ========================================
      case 'acordao':
        return <AcordaoForm {...formProps} />;
      case 'decisao_judicial':
        return <DecisaoJudicialForm {...formProps} />;
      case 'sentenca':
        return <SentencaForm {...formProps} />;

      // ========================================
      // RECESSO
      // ========================================
      case 'indulto_natalino_recesso':
        return <IndultoNatalinoRecessoForm {...formProps} />;
      case 'sustacao_protesto_recesso':
        return <SustacaoProtestoRecessoForm {...formProps} />;
      case 'busca_apreensao_menor_recesso':
        return <BuscaApreensaoMenorRecessoForm {...formProps} />;
      case 'contranotificacao':
        return <ContranotificacaoForm {...formProps} />;
      case 'habeas_corpus_recesso':
        return <HabeasCorpusRecessoForm {...formProps} />;
      case 'impugnacao_penhora_recesso':
        return <ImpugnacaoPenhoraRecessoForm {...formProps} />;
      case 'adjudicacao_compulsoria_recesso':
        return <AdjudicacaoCompulsoriaRecessoForm {...formProps} />;
      case 'mandado_seguranca_recesso':
        return <MandadoSegurancaRecessoForm {...formProps} />;
      case 'manifestacao_recesso':
        return <ManifestacaoRecessoForm {...formProps} />;
      case 'notificacao_extrajudicial':
        return <NotificacaoExtrajudicialForm {...formProps} />;
      case 'cumprimento_provisorio_recesso':
        return <CumprimentoProvisorioRecessoForm {...formProps} />;
      case 'rpv_recesso':
        return <RPVRecessoForm {...formProps} />;
      case 'levantamento_valores':
        return <LevantamentoValoresForm {...formProps} />;
      case 'liberdade_provisoria_recesso':
        return <LiberdadeProvisoriaRecessoForm {...formProps} />;
      case 'penhora_faturamento':
        return <PenhoraFaturamentoForm {...formProps} />;
      case 'penhora_rosto_autos':
        return <PenhoraRostoAutosForm {...formProps} />;
      case 'relaxamento_prisao_recesso':
        return <RelaxamentoPrisaoRecessoForm {...formProps} />;
      case 'revogacao_preventiva_recesso':
        return <RevogacaoPreventivaRecessoForm {...formProps} />;
      case 'revogacao_preventiva_medidas_recesso':
        return <RevogacaoPreventivaMedidasRecessoForm {...formProps} />;
      case 'peticao_incidente_recesso':
        return <PeticaoIncidenteRecessoForm {...formProps} />;
      case 'tutela_antecipada_antecedente':
        return <TutelaAntecipadaAntecedenteForm {...formProps} />;
      case 'tutela_cautelar_antecedente':
        return <TutelaCautelarAntecedenteForm {...formProps} />;
      case 'tutela_antecipada_incidental':
        return <TutelaAntecipadaIncidentalForm {...formProps} />;
      case 'tutela_evidencia_recesso':
        return <TutelaEvidenciaRecessoForm {...formProps} />;
      case 'tutela_cautelar_incidental':
        return <TutelaCautelarIncidentalForm {...formProps} />;

      // ========== CONTRATOS ==========
      case 'criar_contrato':
        return <CriarContratoForm {...formProps} />;
      case 'revisar_contrato':
        return <RevisarContratoForm {...formProps} />;
      case 'analise_contrato_parecer':
        return <AnaliseContratoParecerrForm {...formProps} />;
      case 'analise_negociacao':
        return <AnaliseNegociacaoForm {...formProps} />;
      case 'analise_risco_rescisao':
        return <AnaliseRiscoRescisaoForm {...formProps} />;
      case 'comparar_contratos':
        return <CompararContratosForm {...formProps} />;
      case 'criar_aditivo':
        return <CriarAditivoForm {...formProps} />;
      case 'criar_clausula':
        return <CriarClausulaForm {...formProps} />;
      case 'termo_encerramento':
        return <TermoEncerramentoForm {...formProps} />;
      case 'termos_uso':
        return <TermosUsoForm {...formProps} />;
      case 'contrato_modelo':
        return <ContratoModeloForm {...formProps} />;

      // ========== EXTRAJUDICIAL ==========
      case 'acordo_alimentos_guarda_visitas':
        return <AcordoAlimentosGuardaVisitasForm {...formProps} />;
      case 'acordo_divorcio_completo':
        return <AcordoDivorcioCompletoForm {...formProps} />;
      case 'contranotificacao_extrajudicial':
        return <ContranotificacaoExtrajudicialForm {...formProps} />;
      case 'notificacao_extrajudicial_form':
        return <NotificacaoExtrajudicialExtForm {...formProps} />;
      case 'parecer_juridico':
        return <ParecerJuridicoForm {...formProps} />;
      case 'inventario_extrajudicial':
        return <InventarioExtrajudicialForm {...formProps} />;
      case 'procuracao':
        return <ProcuracaoForm {...formProps} />;
      case 'testamento_particular':
        return <TestamentoParticularForm {...formProps} />;

      default:
        // Fallback para formulário padrão
        break;
    }
  }

  // ========================================
  // FORMULÁRIO PADRÃO (para outros tipos)
  // ========================================
  return (
    <Box>
      {/* Cabeçalho com tipo selecionado */}
      <Paper
        elevation={0}
        sx={{
          p: 2.5,
          mb: 3,
          bgcolor: alpha(areaConfig?.color || theme.palette.primary.main, 0.06),
          border: `1px solid ${alpha(areaConfig?.color || theme.palette.primary.main, 0.2)}`,
          borderRadius: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: alpha(areaConfig?.color || theme.palette.primary.main, 0.15),
              color: areaConfig?.color || theme.palette.primary.main,
            }}
          >
            {AREA_ICONS[documentType.area] || <DescriptionIcon sx={{ fontSize: 24 }} />}
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography variant="h6" fontWeight={600} color="text.primary">
              {documentType.name}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {documentType.description}
            </Typography>
          </Box>
          <Chip
            label={areaConfig?.name || documentType.area}
            sx={{
              bgcolor: alpha(areaConfig?.color || '#4a5568', 0.15),
              color: areaConfig?.color || 'text.secondary',
              fontWeight: 500,
            }}
          />
        </Box>
      </Paper>

      {/* Campos do formulário */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        {/* Nome do Cliente */}
        <Box>
          <Typography variant="subtitle2" fontWeight={600} gutterBottom>
            Nome do seu cliente <Typography component="span" color="error.main">*</Typography>
          </Typography>
          <TextField
            fullWidth
            placeholder="Ex: O autor é Igor Pereira Severino."
            value={values.nome_cliente || ''}
            onChange={(e) => handleFieldChange('nome_cliente', e.target.value)}
            helperText="Separe os nomes com ';' caso você represente mais de uma parte"
          />
        </Box>

        {/* Fatos do Caso */}
        <Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
            <Typography variant="subtitle2" fontWeight={600}>
              Quais são os fatos do caso? <Typography component="span" color="error.main">*</Typography>
            </Typography>
          </Box>
          <TextField
            fullWidth
            multiline
            rows={8}
            placeholder="Descreva detalhadamente os fatos que fundamentam a ação..."
            value={values.fatos_caso || ''}
            onChange={(e) => handleFieldChange('fatos_caso', e.target.value)}
            inputProps={{ maxLength: 10000 }}
            helperText="Seja o mais detalhado possível para que a IA possa gerar um documento preciso"
          />
          <Typography
            variant="caption"
            color={(values.fatos_caso || '').length >= 200 ? 'success.main' : 'text.secondary'}
            sx={{ mt: 0.5, display: 'block' }}
          >
            {(values.fatos_caso || '').length} de 10000 caracteres
            {(values.fatos_caso || '').length < 200 && ` (mínimo: 200)`}
            {(values.fatos_caso || '').length >= 200 && ' ✓'}
          </Typography>
        </Box>

        {/* Parte Contrária */}
        <Box>
          <Typography variant="subtitle2" fontWeight={600} gutterBottom>
            Nome da parte contrária <Typography component="span" color="error.main">*</Typography>
          </Typography>
          <TextField
            fullWidth
            placeholder="Ex: O réu é Manuel Pereira."
            value={values.parte_contraria || ''}
            onChange={(e) => handleFieldChange('parte_contraria', e.target.value)}
          />
        </Box>

        {/* Valor da Causa */}
        <Box>
          <Typography variant="subtitle2" fontWeight={600} gutterBottom>
            Valor da causa
          </Typography>
          <TextField
            fullWidth
            placeholder="R$ 0,00"
            value={values.valor_causa || ''}
            onChange={(e) => {
              const formatted = formatCurrency(e.target.value);
              handleFieldChange('valor_causa', formatted);
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Typography color="text.secondary">R$</Typography>
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Seção de Upload de Documentos */}
      <Paper
        variant="outlined"
        sx={{
          p: 2,
          cursor: 'pointer',
          '&:hover': { bgcolor: 'grey.50' },
        }}
        onClick={() => setShowFileSection(!showFileSection)}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <AttachFileIcon sx={{ color: 'text.secondary' }} />
            <Typography variant="subtitle1" fontWeight={600}>
              Envio de documentos
            </Typography>
            <Chip label="Opcional" size="small" variant="outlined" />
          </Box>
          <IconButton size="small" onClick={(e) => { e.stopPropagation(); setShowFileSection(!showFileSection); }}>
            {showFileSection ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Box>
      </Paper>

      <Collapse in={showFileSection}>
        <Paper variant="outlined" sx={{ p: 2, mt: -1, borderTop: 0, borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Envie contratos, petições anteriores, fotos/prints, ou grave um áudio descrevendo o caso.
          </Typography>

          <input
            ref={fileInputRef}
            type="file"
            accept=".pdf,.docx,.txt,audio/*,image/*"
            multiple
            style={{ display: 'none' }}
            onChange={handleFileSelect}
          />

          <Stack direction="row" spacing={2} sx={{ mb: 2, flexWrap: 'wrap', gap: 1 }}>
            <Button
              variant="outlined"
              startIcon={<AttachFileIcon />}
              onClick={() => fileInputRef.current?.click()}
            >
              Anexar Arquivos
            </Button>

            <AudioRecorder
              onRecordingComplete={handleRecordingComplete}
              disabled={false}
            />

            <Typography variant="caption" sx={{ alignSelf: 'center', color: 'text.secondary' }}>
              PDF, DOCX, TXT, JPG, PNG, MP3, WAV
            </Typography>
          </Stack>

          {/* Lista de arquivos */}
          {uploadedFiles.length > 0 && (
            <Stack spacing={1}>
              {uploadedFiles.map((file, index) => {
                const isAudio = file.type.startsWith('audio/') || file.name.endsWith('.webm') || file.name.endsWith('.mp3');
                const hasTranscription = transcriptions.has(file.name);

                return (
                  <Paper
                    key={index}
                    variant="outlined"
                    sx={{ p: 1.5, display: 'flex', alignItems: 'center', gap: 2 }}
                  >
                    {isAudio ? <WorkIcon sx={{ color: 'text.secondary' }} /> : <DescriptionIcon sx={{ color: 'text.secondary' }} />}
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      <Typography variant="body2" fontWeight={500} noWrap>
                        {file.name}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {(file.size / 1024).toFixed(1)} KB
                      </Typography>
                    </Box>

                    {/* Ações para áudio */}
                    {isAudio && (
                      <Stack direction="row" spacing={1}>
                        <IconButton
                          size="small"
                          color={playingAudio === file.name ? "primary" : "default"}
                          onClick={() => handleToggleAudio(file)}
                          title={playingAudio === file.name ? "Pausar" : "Reproduzir"}
                        >
                          {playingAudio === file.name ? <PauseIcon fontSize="small" /> : <PlayArrowIcon fontSize="small" />}
                        </IconButton>

                        {hasTranscription && (
                          <IconButton
                            size="small"
                            color="info"
                            onClick={() => setTranscriptionDialog({
                              open: true,
                              fileName: file.name,
                              text: transcriptions.get(file.name) || ''
                            })}
                            title="Ver transcrição"
                          >
                            <TextFieldsIcon fontSize="small" />
                          </IconButton>
                        )}
                      </Stack>
                    )}

                    <IconButton size="small" color="error" onClick={() => onFileRemove(index)}>
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Paper>
                );
              })}
            </Stack>
          )}
        </Paper>
      </Collapse>

      <Divider sx={{ my: 3 }} />

      {/* Estilo de Escrita */}
      <Paper variant="outlined" sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
          <DescriptionIcon sx={{ color: 'text.secondary' }} />
          <Typography variant="subtitle1" fontWeight={600}>
            Estilo de escrita
          </Typography>
          <Tooltip
            title={
              <Box sx={{ p: 1 }}>
                <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                  Como a Advogada Parceira ajusta o estilo de escrita
                </Typography>
                <Typography variant="body2" paragraph sx={{ mb: 1 }}>
                  A Advogada Parceira adapta o estilo de escrita à complexidade do tema e à finalidade da peça.
                </Typography>
                <Typography variant="body2" paragraph sx={{ mb: 1 }}>
                  Questões simples são tratadas com clareza, objetividade e linguagem direta, evitando formalismo desnecessário.
                </Typography>
                <Typography variant="body2" paragraph sx={{ mb: 1 }}>
                  Temas mais complexos ou sensíveis recebem tratamento técnico mais aprofundado, com fundamentação jurídica adequada e precisão conceitual.
                </Typography>
                <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 600 }}>
                  O objetivo é manter um equilíbrio profissional:
                </Typography>
                <ul style={{ margin: 0, paddingLeft: 20 }}>
                  <li><Typography variant="caption">clareza sem perda de rigor,</Typography></li>
                  <li><Typography variant="caption">formalidade sem excessos,</Typography></li>
                  <li><Typography variant="caption">simplicidade quando possível,</Typography></li>
                  <li><Typography variant="caption">densidade técnica quando necessária.</Typography></li>
                </ul>
              </Box>
            }
            arrow
            placement="top"
          >
            <InfoIcon sx={{ color: 'text.secondary', fontSize: 18, cursor: 'pointer' }} />
          </Tooltip>
        </Box>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          O estilo de escrita é ajustado conforme a complexidade do tema: assuntos simples são tratados com objetividade e clareza; questões mais complexas recebem fundamentação técnica adequada, sempre com linguagem profissional.
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          {WRITING_STYLES.map((style) => (
            <Paper
              key={style.id}
              variant="outlined"
              onClick={() => setSelectedStyle(style.id)}
              sx={{
                p: 2,
                cursor: 'pointer',
                border: selectedStyle === style.id ? `2px solid ${theme.palette.primary.main}` : '1px solid',
                borderColor: selectedStyle === style.id ? 'primary.main' : 'grey.200',
                bgcolor: selectedStyle === style.id ? alpha(theme.palette.primary.main, 0.04) : 'transparent',
                '&:hover': {
                  borderColor: 'primary.main',
                  bgcolor: alpha(theme.palette.primary.main, 0.02),
                },
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Radio
                  checked={selectedStyle === style.id}
                  size="small"
                  sx={{ p: 0, mr: 0.5 }}
                />
                <Typography variant="subtitle2" fontWeight={600}>
                  {style.name}
                </Typography>
              </Box>
              <Typography variant="caption" color="text.secondary" sx={{ ml: 3.5 }}>
                {style.description}
              </Typography>
            </Paper>
          ))}

          <Paper
            variant="outlined"
            sx={{
              p: 2,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              '&:hover': { bgcolor: 'grey.50' },
            }}
          >
            <Box
              sx={{
                width: 24,
                height: 24,
                borderRadius: '50%',
                border: '2px dashed',
                borderColor: 'grey.400',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography color="grey.500" fontSize={14}>+</Typography>
            </Box>
            <Typography variant="subtitle2" color="text.secondary">
              Criar estilo personalizado
            </Typography>
          </Paper>
        </Box>
      </Paper>

      {/* Dica */}
      <Alert
        severity="info"
        icon={<InfoIcon />}
        sx={{
          mt: 3,
          borderRadius: 2,
        }}
      >
        <Typography variant="body2">
          <strong>Dica:</strong> Quanto mais detalhada for a descrição dos fatos, melhor será o documento gerado pela IA.
          Você poderá revisar e editar o documento antes de finalizá-lo.
        </Typography>
      </Alert>

      {/* Dialog de Transcrição */}
      <Dialog
        open={transcriptionDialog.open}
        onClose={() => setTranscriptionDialog({ ...transcriptionDialog, open: false })}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Transcrição: {transcriptionDialog.fileName}
        </DialogTitle>
        <DialogContent dividers>
          <TextField
            fullWidth
            multiline
            rows={10}
            value={transcriptionDialog.text}
            onChange={(e) => setTranscriptionDialog({ ...transcriptionDialog, text: e.target.value })}
            variant="outlined"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setTranscriptionDialog({ ...transcriptionDialog, open: false })}>
            Fechar
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              // Atualizar o estado local
              setTranscriptions(prev => new Map(prev).set(transcriptionDialog.fileName, transcriptionDialog.text));

              // Opcional: Atualizar fatos do caso se desejar (complexo pois teria que substituir a parte correspondente)
              // Por enquanto apenas fechamos
              setTranscriptionDialog({ ...transcriptionDialog, open: false });
            }}
          >
            Salvar Alterações
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default DynamicDocumentForm;
